import React from "react";
import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import IconAdd from "../../dynamicicons/icon-add";
import imageAsset from "../../img/asset.svg";
import OnboardingFrame from "./onboarding-frame";
import { OnboardingFrameProps } from "./onboarding-shared-data";
import * as styles from "./onboarding-step-assets.module.scss";
import whitelabel from "../../whitelabel";

export default function OnboardingStepAssets(props: OnboardingFrameProps) {
	const { t } = useTranslation();
	return (
		<OnboardingFrame
			title={t("onboarding.assets.title")}
			description={t("onboarding.assets.description")}
			buttonSecondary={{
				label: t("onboarding.assets.back"),
				onClick: props.navigateBackwards,
			}}
			buttonPrimary={{
				label: t("onboarding.assets.finish"),
				onClick: props.navigateForwards,
			}}
			centerContent
			notice={t("onboarding.assets.notice")}
		>
			<Link
				className={styles.content}
				to="/assets/create"
				onClick={props.navigateForwards}
			>
				<img src={imageAsset} alt="" />
				<div className={styles.button}>
					<IconAdd
						size={16}
						color={whitelabel.palette.secondary900}
					/>
					<span className={styles.buttonLabel}>
						{t("onboarding.assets.add_asset")}
					</span>
				</div>
			</Link>
		</OnboardingFrame>
	);
}
